import { useInView } from "react-intersection-observer";
import { useState, useEffect, CSSProperties } from "react";

function VizSensor(props: any) {
  const {
    bottom = -400, minHeight = 400, height, useDefaultMinHeight = true, forceSSR,
    // placeHolder,
  } = props;

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once when element becomes visible
    rootMargin: `0px 0px ${Math.abs(bottom)}px 0px`, // Load before entering viewport
  });

  const style: CSSProperties = {};
  if (useDefaultMinHeight) {
    style.minHeight = minHeight;
  }
  if (height) {
    style.height = height;
  }

  if (forceSSR) {
    return props.children;
  }

  const finalPlaceHolder = <div style={style} />;

  // use VizSensor on client side only.
  if (isClient) {
    return (
      <div ref={ref}>
        {inView ? props.children : finalPlaceHolder}
      </div>
    );
  }
  return <span style={{ ...style, display: "inline-block" }} />;
}

export default VizSensor;
